import React, {Fragment} from "react";
import SVG from 'react-inlinesvg';
import icnArrowBack from '../../../../assets/svg/actions/icn-arrow-back.svg';
import {Link} from "react-router-dom";
import {withRouter} from "react-router-dom";

const HeaderLeftSide = props => {

    let header;

    const getPrevPageName = () => {
        let urlSegments = props.location.pathname.split('/');
        let urlSegmentsLength = urlSegments.length
        return urlSegments.splice(urlSegmentsLength - 2, 1).pop().split('-').join(' ');
    }

    switch (props.header) {
        case 'detail': {
            header = (
                <Fragment>
                    <Link to="#" onClick={() => { props.history.goBack() }} className="page-back">
                        <SVG src={icnArrowBack}/>
                        <span>{getPrevPageName()}</span>
                    </Link>
                    <h1>{props.title}</h1>
                </Fragment>
            );
        };break;
        default: {
            header = (
                <h1>{props.title}</h1>
            );
        };break;
    }

    return (
        <Fragment>
            <div className="menu-left">
                {header}
            </div>
        </Fragment>
    );

};

export default withRouter(HeaderLeftSide);